export const generalDictionary = {
    "No hay datos para mostrar": {
        es: "No hay datos para mostrar",
        en: "No data to show",
    },
    "No hay resultados": {
        es: "No hay resultados",
        en: "No results",
    },
    "Ver más": {
        es: "Ver más",
        en: "More",
    },
    "Ver menos": {
        es: "Ver menos",
        en: "",
    },
    "MERCADO ABIERTO": {
        es: "MERCADO ABIERTO",
        en: "OPEN MARKET",
    },
    "MERCADO CERRADO": {
        es: "MERCADO CERRADO",
        en: "CLOSED MARKET",
    },
    DESTACADO: {
        es: "DESTACADO",
        en: "FEATURED",
    },
    "ACTUALIZACIÓN C/ 20 MIN": {
        es: "ACTUALIZACIÓN C/ 20 MIN",
        en: "UPDATED EVERY 20 MIN",
    },
    Inicio: {
        es: "Inicio",
        en: "Home",
    },
    "No se encontraron datos para visualizar el gráfico": {
        es: "No se encontraron datos para visualizar el gráfico",
        en: "No data to show the chart",
    },
};
